import { AntDesign, Feather, FontAwesome6, Ionicons, MaterialIcons } from '@expo/vector-icons';

import { OptionItemProps } from '@/components/settings/OptionItem';
import { i18n } from '@/utils/i18n';

import { SettingsRoutes } from './SettingsRoutesNames';

const your_preferences = i18n.t('settings.screen_names.your_preferences');
const mileage_radius = i18n.t('settings.screen_names.mileage_radius');
const edit_name = i18n.t('settings.screen_names.edit_name');
const change_password = i18n.t('settings.screen_names.change_password');
const favorites = i18n.t('settings.screen_names.favorites');
const payment_methods = i18n.t('settings.screen_names.payment_methods');
const transactions = i18n.t('settings.screen_names.transactions');
const subscriptions = i18n.t('settings.screen_names.subscriptions');
const privacy_policy = i18n.t('settings.screen_names.privacy_policy');
const merchantDocuments = i18n.t('settings.screen_names.merchant_documents');
const terms_conditions = i18n.t('settings.screen_names.terms_conditions');
const faq = i18n.t('settings.screen_names.faq');
const contact_bs = i18n.t('settings.screen_names.contact');
const showTitle = i18n.t('settings.screen_names.show_title');
const giftsTitle = i18n.t('settings.screen_names.gifts_title');
const log_out = i18n.t('settings.screen_names.logout');
const delete_account = i18n.t('settings.screen_names.delete_account');

// Screens
export const menuOptions: OptionItemProps[] = [
  {
    label: your_preferences,
    icon: <MaterialIcons name="favorite" size={24} color="black" />,
    screen: SettingsRoutes.PREFERENCES,
    userType: ['ALL']
  },
  {
    label: mileage_radius,
    icon: <AntDesign name="environment" size={24} color="black" />,
    screen: SettingsRoutes.RADIUS,
    userType: ['INDIVIDUAL']
  },
  {
    label: edit_name,
    icon: <MaterialIcons name="person-outline" size={24} color="black" />,
    screen: SettingsRoutes.EDIT_NAME,
    userType: ['INDIVIDUAL']
  },
  {
    label: change_password,
    icon: <AntDesign name="lock" size={24} color="black" />,
    screen: SettingsRoutes.CHANGE_PASSWORD,
    userType: ['NON_PROFIT_ORG']
  },
  {
    label: favorites,
    icon: <MaterialIcons name="favorite-border" size={24} color="black" />,
    screen: SettingsRoutes.FAVORITES,
    userType: ['ALL']
  },
  {
    label: privacy_policy,
    icon: <AntDesign name="eye" size={24} color="black" />,
    screen: SettingsRoutes.PRIVACY_POLICY,
    userType: ['ALL']
  },
  {
    label: merchantDocuments,
    icon: <Ionicons name="documents-outline" size={24} color="black" />,
    screen: SettingsRoutes.MERCHANT_DOCUMENTS,
    userType: ['NON_PROFIT_ORG']
  },
  {
    label: payment_methods,
    icon: <FontAwesome6 name="dollar-sign" size={24} color="black" />,
    screen: SettingsRoutes.PAYMENT_METHODS,
    userType: ['INDIVIDUAL']
  },
  {
    label: transactions,
    icon: <FontAwesome6 name="dollar-sign" size={24} color="black" />,
    screen: SettingsRoutes.TRANSACTIONS,
    userType: ['INDIVIDUAL']
  },
  {
    label: subscriptions,
    icon: <FontAwesome6 name="dollar-sign" size={24} color="black" />,
    screen: SettingsRoutes.SUBSCRIPTIONS,
    userType: ['INDIVIDUAL']
  },
  {
    label: terms_conditions,
    icon: <AntDesign name="file-text" size={24} color="black" />,
    screen: SettingsRoutes.TERMS_CONDITIONS,
    userType: ['ALL']
  },
  {
    label: faq,
    icon: <AntDesign name="info-circle" size={24} color="black" />,
    screen: SettingsRoutes.FAQ,
    userType: ['ALL']
  },
  {
    label: contact_bs,
    icon: <Ionicons name="mail-outline" size={24} color="black" />,
    screen: SettingsRoutes.CONTACT_BS,
    userType: ['ALL']
  },
  {
    label: showTitle,
    icon: <MaterialIcons name="movie" size={24} color="black" />,
    screen: SettingsRoutes.SHOW,
    userType: ['INDIVIDUAL']
  },
  {
    label: giftsTitle,
    icon: <FontAwesome6 name="gift" size={24} color="black" />,
    screen: SettingsRoutes.GIFTS,
    userType: ['INDIVIDUAL']
  },

  {
    label: log_out,
    icon: <AntDesign name="logout" size={24} color="black" />,
    screen: SettingsRoutes.LOG_OUT,
    userType: ['ALL']
  },
  {
    label: delete_account,
    icon: <Feather name="trash-2" size={24} color="black" />,
    screen: SettingsRoutes.DELETE_ACCNT,
    userType: ['ALL']
  }
];
